import View, { ViewOpts } from '@play-co/timestep-core/lib/ui/View';
import {
  ImageCoverView,
  ImageCoverViewOpts,
  ImageScaleView,
  ImageScaleViewOpts,
  ImageView,
} from '@play-co/timestep-core/ui';
import { ImageViewOpts } from '@play-co/timestep-core/lib/ui/ImageView';
import MaskedView from '../../lib/ui/components/MaskedView';
import LangBitmapFontTextView, {
  LangBitmapOpts,
} from '../../lib/ui/components/LangBitmapFontTextView';

export type HudMeterOpts = {
  view: ViewOpts;
  image: ImageCoverViewOpts;
  fill: ImageViewOpts;
  mask: Omit<
    ConstructorParameters<typeof MaskedView>[0],
    'sourceView' | 'superview'
  >;
  highlight: ImageCoverViewOpts;
  label: ImageScaleViewOpts;
  text: LangBitmapOpts;
};

export class HudMeter extends View {
  private meter: MaskedView;
  private label: LangBitmapFontTextView;

  constructor({
    view,
    image,
    fill,
    mask,
    highlight,
    label,
    text,
  }: HudMeterOpts) {
    super(view);
    const { width } = view;

    const meterBackground = this.addSubview(new ImageCoverView(image));
    this.meter = new MaskedView({
      ...mask,
      superview: meterBackground,
      sourceView: new ImageView(fill),
    });

    this.addSubview(new ImageCoverView(highlight));

    const labelWidth = width - 12;
    const labelBackground = this.addSubview(
      new ImageScaleView({
        ...label,
        x: 3,
        width: labelWidth,
      }),
    );

    this.label = new LangBitmapFontTextView({
      ...text,
      superview: labelBackground,
      width: labelWidth - 2 * text.x,
    });
  }

  public setMeterValue(value: number) {
    this.label.localeText = () => `${Math.ceil(value * 100)} %`;
    this.meter.updateSourceOpts({
      offsetY: (1 - value) * this.meter.style.height,
    });
  }

  public updateLabelOpts(opts: Partial<LangBitmapOpts>) {
    this.label.updateOpts(opts);
  }
}
